import { layout } from '@features/lci-report/domain/dimensions';
import { themeV2 } from '@features/lci-report/domain/theme-v2';
import { DEFAULT_FONT } from '@features/lci-report/utils/constants-v2';
import { contentSlideHeaderV2 } from '@features/lci-report/utils/slide-header-v2';
import type { Slide, TextProps } from '@features/powerpoint';
import { getColumnXPositions } from '@features/powerpoint';
import { partition } from '@utils/arrays';
import { MASTER_NAMES } from '@features/lci-report/utils/shared-presentation-config-v2';
import { getDefinitionsV2 } from './domain/content-v2';
import { calculateRunningTotal } from './domain/pages';
import type { Glossary } from '@features/glossary';

const COLUMNS_PER_PAGE = 2;
const FONT_SIZE = 10;

const COLUMNS = getColumnXPositions(
  0.33,
  layout.width - 2 * 0.33,
  COLUMNS_PER_PAGE,
  0.4
);

type GlossarySlidesV2Props = {
  entriesPerColumn: readonly number[];
  glossary: Glossary;
};

export const glossarySlidesV2 = (props: GlossarySlidesV2Props): Slide[] => {
  const glossaryEntries = Object.values(props.glossary).toSorted((a, b) =>
    a.label.localeCompare(b.label)
  );
  const pages = partition(props.entriesPerColumn, COLUMNS_PER_PAGE);
  const runningTotal = calculateRunningTotal(props.entriesPerColumn);
  const totalEntries = props.entriesPerColumn.reduce(
    (acc, cur) => acc + cur,
    0
  );

  if (totalEntries !== glossaryEntries.length)
    console.error(
      `Glossary entry count does not match totals per column: Got ${totalEntries}, expected ${glossaryEntries.length}`
    );

  return pages.map((columnEntries, pageIndex) => ({
    slideMaster: MASTER_NAMES.titleAndContent,
    texts: [
      contentSlideHeaderV2('Glossary', {
        color: themeV2.colors.metricBlue,
      }),
      ...columnEntries.map(
        (_, columnIndex): TextProps => ({
          ...getDefinitionsV2(
            glossaryEntries,
            pageIndex * COLUMNS_PER_PAGE + columnIndex,
            runningTotal
          ),
          options: {
            fontSize: FONT_SIZE,
            fontFace: DEFAULT_FONT,
            x: COLUMNS.positions[columnIndex],
            y: 1.1,
            w: COLUMNS.columnWidth,
            h: layout.height - 1.4,
            color: themeV2.colors.black,
            valign: 'top',
          },
        })
      ),
    ],
  }));
};
